import React from 'react';
import { motion, HTMLMotionProps } from 'framer-motion';
import { Loader2 } from 'lucide-react';
interface ButtonProps extends Omit<HTMLMotionProps<'button'>, 'onClick'> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg' | 'xl';
  isLoading?: boolean;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
  scrollTo?: string;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
}
export function Button({
  className = '',
  variant = 'primary',
  size = 'md',
  isLoading = false,
  leftIcon,
  rightIcon,
  scrollTo,
  onClick,
  children,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-full font-bold transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none';
  const variants = {
    primary: 'bg-[#ff8c42] text-white hover:bg-[#ff7a20] shadow-lg shadow-orange-500/20',
    secondary: 'bg-white text-[#0a0e27] hover:bg-gray-100',
    outline: 'border-2 border-[#ff8c42] text-[#ff8c42] hover:bg-[#ff8c42]/10',
    ghost: 'text-gray-300 hover:text-white hover:bg-white/10'
  };
  const sizes = {
    sm: 'h-9 px-4 text-sm',
    md: 'h-11 px-6 text-base',
    lg: 'h-14 px-8 text-lg',
    xl: 'h-16 px-10 text-xl'
  };
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (scrollTo) {
      e.preventDefault();
      const element = document.getElementById(scrollTo);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    }
    if (onClick) {
      onClick(e);
    }
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} disabled={isLoading} onClick={handleClick} {...props} data-id="element-344">
      {isLoading && <Loader2 className="mr-2 h-4 w-4 animate-spin" data-id="element-345" />}
      {!isLoading && leftIcon && <span className="mr-2" data-id="element-346">{leftIcon}</span>}
      {children}
      {!isLoading && rightIcon && <span className="ml-2" data-id="element-347">{rightIcon}</span>}
    </motion.button>;
}